<template>
    <v-card>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <v-container>
                <v-row class="d-flex">
                    <v-col cols="3">
                        <div class="text-h5 black--text font-weight-bold">Farm Location</div>
                            <!-- <v-text-field
                                outlined
                                dense
                                @input="getGoogleAddress"
                            ></v-text-field> -->
                            <!-- <input 
                                type="text" 
                                id="autocomplete" 
                                name="fname"
                                ref="autocomplete" 
                            /> -->
                            <gmap-autocomplete  :value="address" @place_changed="setPlace" >
                                <v-text-field
                                    outlined
                                    dense
                                    ref="input"
                                    class="place-input"
                                ></v-text-field>
                            </gmap-autocomplete>
                        <div class="mt-4 subtitle-1 black--text font-weight-bold">Address </div>

                        <div class="text-h5 black--text font-weight-bold">Geographic Location</div>

                        <div class="mt-4 subtitle-1 black--text font-weight-bold">Latitude  </div>
                        <v-text-field
                            v-model="latitude"
                            outlined
                            dense
                        ></v-text-field>

                        <div class=" subtitle-1 black--text font-weight-bold">Longitude</div>
                        <v-text-field
                            v-model="longitude"
                            outlined
                            dense
                        ></v-text-field>


                        <v-btn @click="startGeoFenceTool" block color="primary" class="mt-5" depressed>Subsection</v-btn>
                    </v-col>
                    <v-col cols="9">
                        <div class="google-map" style="width:100%;height:520px" id="map" ref="googleMap"></div>
                        <div class="d-flex justify-center mt-n12">
                            <v-btn v-if="startGeoFence" @click="saveGeoFence" width="200" color="primary" class="" depressed>Done</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </v-card>
</template>
<script>
import { Loader } from '@googlemaps/js-api-loader';
import FarmService from "@/_services/farmService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
    async mounted() {
        this.startLoading()
        const {data} = await FarmService.getPrimaryFarm();
        this.orgFarm = data;
        this.stopLoading();
        this.latitude  = this.orgFarm.lat;
        this.longitude = this.orgFarm.log;
        this.address = this.orgFarm.address;
        this.mapOptions.center.lat = this.latitude;
        this.mapOptions.center.lng = this.longitude;
        var codes = this.orgFarm.coordinates.map(function(elm) {
            return { lat: parseFloat(elm['lat']), lng: parseFloat(elm['log'])};
        });
        this.parentPolygonCoords = codes;
        try {
            const loader = await new Loader({
                apiKey: "AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4",
                libraries: ["places", "map"]
            }).load()
            .then((google) => {
                this.google = google;
                this.initializeMap(google);
            })
            .catch(e => {
                console.log('Map', e);
            });
            this.loader = loader;
        
        }catch(e) {
            console.log(e);
        }
    },
    props: {
        showMap: {
            type: Boolean,
            require: true
        }
    },

    data() {
        return {
            address: '',
            orgFarm: {},
            startGeoFence: false,
            parentPolygonCoords: [],
            subPolygonCoords: [],
            loader: null,
            latitude: 0,
            longitude: 0,
            google: null,
            map: null,
            marker: null,
            polygon: null,
            subPolygon: null,
            mapOptions: {
                center: {
                    lat: -34.397,
                    lng: 150.644
                },
                styles: {
                    overflow: 'visible'
                },
                zoom: 9,
                disableDefaultUI: true
            },
            breadcrumbs: [
				{
					text: 'Dashboard',
					disabled: false,
					to: '/',
				},
				{
					text: 'Farm',
					disabled: true,
				},
                {
					text: 'Geofence',
					disabled: true,
				},
			],
        }
    },

    methods: {
        setPlace(place) {
            const latLng = {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()};
            this.map.setCenter(latLng)
            this.latitude = latLng.lat;
            this.longitude = latLng.lng;
            // console.log('set place', latLng)

        },
        saveGeoFence() {
            this.startGeoFence = false;
            this.subPolygonCoords = [];
            this.subPolygon.setEditable(false);
            var updated = [];
            const vertices = this.subPolygon.getPath();
            for (let i = 0; i < vertices.getLength(); i++) {
                const xy = vertices.getAt(i);
                updated.push({lat: xy.lat() , lng: xy.lng()});
            }

            this.subPolygonCoords = updated;
            // console.log(this.subPolygonCoords)
        },
        startGeoFenceTool() {
            this.startGeoFence = true;
            this.map.addListener("click", (mapsMouseEvent) => {
                this.updatePolygon(mapsMouseEvent)
            });
            this.polygon.addListener("click", (mapsMouseEvent) => {
                this.updatePolygon(mapsMouseEvent)
            });
        },
        updatePolygon(mapsMouseEvent) {
            const latLng = mapsMouseEvent.latLng.toJSON();
            this.subPolygonCoords.push(latLng);
            if(this.isAnyCrossover(this.subPolygonCoords)){
                this.subPolygonCoords.pop();
                this.$notify({
					title: "No crossover allowed.",
					type: "error",
				});
            }
            this.createPolygon();
        },
        createPolygon() {
            if(this.subPolygon != null) this.subPolygon.setMap(null);
            this.subPolygon = new this.google.maps.Polygon({
                paths: this.subPolygonCoords,
                strokeColor: "#1F5D51",
                strokeOpacity: 0.8,
                strokeWeight: 4,
                fillColor: "#E5F8F1",
                fillOpacity: 0.7,
                editable: true,
                dragable: true,
                strokePosition: this.google.maps.StrokePosition.INSIDE,
            });
            this.google.maps.event.addListener(this.subPolygon.getPath(), 'set_at',   this.markerCoords);
            this.google.maps.event.addListener(this.subPolygon.getPath(), 'insert_at', this.markerCoords);
            this.google.maps.event.addListener(this.subPolygon.getPath(), 'remove_at', this.markerCoords);
            this.subPolygon.setMap(this.map);
        },
        isAnyCrossover(coordinates) {
            // NOTE: this currently returns a crossover coordinate or a null but could just return a true/false
            if (coordinates.length >= 4) { 
                // can only have crossover if polygon length >= 4
                for (let i = 0; i < coordinates.length-2; i++) {
                    for (let j = i+1; j < coordinates.length-1; j++) {
                        if (this.doEdgesIntersect(
                        coordinates[i].lat,   coordinates[i].lng,
                        coordinates[i+1].lat, coordinates[i+1].lng,
                        coordinates[j].lat,   coordinates[j].lng,
                        coordinates[j+1].lat, coordinates[j+1].lng)) {
                            return true;
                        }
                        if (this.doEdgesIntersect( // wrap around line segment
                        coordinates[coordinates.length-1].lat, coordinates[coordinates.length-1].lng,
                        coordinates[0].lat,                    coordinates[0].lng,
                        coordinates[j].lat,                    coordinates[j].lng,
                        coordinates[j+1].lat,                  coordinates[j+1].lng)) {
                            return true;
                        }
                    }
                }
            }
            return false; // no crossover detected
        },

        doEdgesIntersect(a,b,c,d,p,q,r,s) {
            let det, gamma, lambda;
            det = (c - a) * (s - q) - (r - p) * (d - b);
            if (det === 0) {
                return false;
            } else {
                lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det;
                gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det;
                return (0 < lambda && lambda < 1) && (0 < gamma && gamma < 1);
            }
        },

        closeModal() {
          this.polygon.setMap(null);
          this.parentPolygonCoords = [];
        },

        async markerCoords(e) {
            const vertices = this.subPolygon.getPath();
            var updated = [];
            for (let i = 0; i < vertices.getLength(); i++) {
                const xy = vertices.getAt(i);
                updated.push({lat: xy.lat() , lng: xy.lng()});
            }
            // Check polygon is in parent polygon
            console.log(e);
            // const resultPath = await this.google.maps.geometry.poly.containsLocation(updated[e],this.polygon)? true : false;
            // if(!resultPath){
            //     updated.splice(e, 1);
            // }
            this.subPolygonCoords = updated;
            this.createPolygon();
        },

        async initializeMap(google) {
            this.google = google;
            const mapContainer = this.$refs.googleMap
            this.map = await new google.maps.Map(mapContainer, this.mapOptions);
            // Add Marker on map click
            // this.marker = await new google.maps.Marker({
            //     position: this.mapOptions.center,
            //     map: this.map,
            // });
            // this.marker.setIcon('http://maps.google.com/mapfiles/ms/icons/green-dot.png');

            this.polygon = new google.maps.Polygon({
                paths: this.parentPolygonCoords,
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
            });
        
            this.polygon.setMap(this.map);

            this.map.addListener("click", (mapsMouseEvent) => {
                const latLng = mapsMouseEvent.latLng.toJSON();
                this.latitude = latLng.lat;
                this.longitude = latLng.lng;
            });
        },

    },
    mixins: [loadingMixin]
}

</script>
<style>
.pac-target-input {
    border: 1px solid #898989;
    border-radius: 3px;
    min-height: 40px;
    width: 100%;
    padding: 0px 12px;
    caret-color: #00bd73;
}
.pac-target-input:focus-visible{
    border:1px solid #00bd73;
    outline: none;
}

</style>